import { render, staticRenderFns } from "./BodyViewer.vue?vue&type=template&id=200158de&scoped=true&"
import script from "./BodyViewer.vue?vue&type=script&lang=js&"
export * from "./BodyViewer.vue?vue&type=script&lang=js&"
import style0 from "./BodyViewer.vue?vue&type=style&index=0&id=200158de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200158de",
  null
  
)

export default component.exports